/* eslint-disable react-hooks/rules-of-hooks */
import { useQuery } from '@apollo/client';
import { SimpleGrid, useDisclosure, Flex, Text } from '@chakra-ui/react';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SearchInput from '../../../../components/FormGroup/SearchInput';
import Pagination from '../../../../components/Pagination';
import { GET_PAGES } from '../../../../graphQL/queries';
import { Page } from '../../../../shared/models/page';
import { Pagination as PagePagination } from '../../../../shared/models/pagination';
import DynamicPageModal from '../DynamicPageModal';
import PageListItem from './PageItem';

type PageListProps = {
  onPageToEdit?: (page: Page) => void;
};

const PageList: FC<PageListProps> = () => {
  const { data, refetch } = useQuery<{ pagesPaginated: PagePagination<Page> }>(
    GET_PAGES,
    {
      variables: {
        limit: 12,
      },
    },
  );
  const [pages, setPages] = useState<Page[]>([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [pageToEdit, setPageToEdit] = useState<Page | null>(null);
  const { t } = useTranslation();
  useEffect(() => {
    setPages(data?.pagesPaginated.data || []);
  }, [data?.pagesPaginated.data]);

  const onSearch = async (search: string) => {
    refetch({ search_text: search });
  };

  return (
    <>
      <DynamicPageModal
        isOpen={isOpen}
        PageToEdit={pageToEdit}
        onClose={() => {
          onClose();
          setPageToEdit(null);
        }}
      />

      <SearchInput
        onSearch={onSearch}
        activeDebounce
        borderColor="gray.400"
        ml="auto"
        mb={4}
      />

      {!pages.length && (
        <Text mx="auto" opacity="0.8">
          {t('noPagesFounded')}
        </Text>
      )}

      <SimpleGrid spacing={2} columns={{ sm: 1, md: 2 }} flexWrap="wrap">
        {pages.map(page => (
          <PageListItem
            onPageItemToEdit={() => {
              setPageToEdit(page);
              onOpen();
            }}
            key={page.id}
            page={page}
          />
        ))}
      </SimpleGrid>

      <Flex justifyContent="center" mt="4">
        <Pagination
          current={data?.pagesPaginated.page || 1}
          perPage={data?.pagesPaginated.limit || 10}
          total={data?.pagesPaginated.total || 0}
          onPageChange={page => {
            if (data && page > data.pagesPaginated.totalPages) return;
            refetch({ page });
          }}
        />
      </Flex>
    </>
  );
};

export default PageList;
